import axios from '@/requests';
import { Screenshot } from '@/store/modules/screenshot/types';
export const screenshotAPI = {
    async getScreenshotListByUid(projId: string, uid: string) {
        try {
            const res = await axios.get<Screenshot[]>('/ScreenShot/getScreenShotListByUid', { "projId": projId, "uid": uid });
            return res;
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async getScreenshotListByUidAndTime(projId: string, uid: string, time: string) {
        try {
            const res = await axios.get<Screenshot[]>('/ScreenShot/getScreenShotListByUidAndTime', { "projId": projId, "uid": uid, "time": time });
            return res;
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async getServerPath(uid: string) {
        try {
            const res = await axios.get<string>('/ScreenShot/getServerPath', { "uid": uid });
            return res;
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async getScreenShotListByUidAndTimeAndPage(projId: string, uid: string, time: string, page: number, size: number) {
        try {
            const res = await axios.get<Screenshot[]>('/ScreenShot/getScreenShotListByUidAndTimeAndPage', { "projId": projId, "uid": uid, "time": time, "size": size, "page": page });
            return res;
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async getScreenShotListByUidAndPage(projId: string, uid: string, page: number, size: number) {
        try {
            const res = await axios.get<Screenshot[]>('/ScreenShot/getScreenShotListByUidAndPage', { "projId": projId, "uid": uid, "size": size, "page": page });
            return res;
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async getScreenShotCountByProjIdAndUid(projId: string, uid: string, time: string) {
        try {
            const res = await axios.get<number>('/ScreenShot/getScreenShotCountByProjIdAndUid', { "projId": projId, "uid": uid, "time": time });
            return res;
        } catch (err) {
            return Promise.reject(err);
        }
    },
    //

}